import { VehicleList } from "./VehicleList";

export function TrucksList() {
  return <VehicleList resource="trucks" />;
}
